import {
  IFormulaSegment,
  IUpdateCalculationModifier,
  IUpdateTimeModifier,
  IVariables,
} from '~/pages/FinancialModelDeprecated/entity/types';
import shiftFormulaIndexes from '~/pages/FinancialModelDeprecated/utils/shiftFormulaIndexes';
import updateFormulaAndVariables from '~/pages/FinancialModelDeprecated/utils/updateFormulaAndVariables';

const handlePercentage = (value: string): string => {
  if (value.includes('%')) {
    return (parseFloat(value.replace('%', '')) / 100).toString();
  }
  return value;
};

export const handlePaste = ({
  event,
  inputPosition,
  setInputPosition,
  updatedFormula,
  setUpdatedFormula,
  setFormula,
  variables,
  setVariables,
  handleUpdateCalculationModifier,
  handleUpdateTimeModifier,
  formulaUuid,
  setValue,
  inputRef,
}: {
  event: React.ClipboardEvent<HTMLDivElement>;
  inputPosition: number;
  setInputPosition: React.Dispatch<React.SetStateAction<number>>;
  updatedFormula: IFormulaSegment[];
  setUpdatedFormula: React.Dispatch<React.SetStateAction<IFormulaSegment[]>>;
  setFormula: React.Dispatch<React.SetStateAction<IFormulaSegment[]>>;
  variables: IVariables;
  setVariables: React.Dispatch<React.SetStateAction<IVariables>>;
  handleUpdateCalculationModifier?: ({
    calculationModifier,
    formulaForUpdate,
    formulaTextValue,
    refToUpdate,
  }: IUpdateCalculationModifier) => void;
  handleUpdateTimeModifier: ({
    timeModifier,
    formulaForUpdate,
    formulaTextValue,
    refToUpdate,
  }: IUpdateTimeModifier) => void;
  formulaUuid?: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  inputRef: React.RefObject<HTMLDivElement>;
}): void => {
  event.preventDefault();
  const text = event.clipboardData.getData('text/plain');
  const handledText = handlePercentage(text);
  const pastedText = handledText.replace(/[$,]/g, '').replace(/[^0-9.]/g, '');
  const { newFormula, newVariables } = updateFormulaAndVariables({
    valuesToAdd: [
      {
        type: 'constant',
        value: pastedText,
        newIndex: inputPosition,
      },
    ],
    formulaCopy: [...updatedFormula],
    variablesCopy: { ...variables },
    formulaUuid,
    handleUpdateCalculationModifier,
    handleUpdateTimeModifier,
  });

  const { formulaWithShiftedIndexes, variablesWithShiftedIndexes } = shiftFormulaIndexes({
    oldFormula: newFormula,
    oldVariables: newVariables,
  });

  setFormula(formulaWithShiftedIndexes);
  setVariables(variablesWithShiftedIndexes);

  setUpdatedFormula(formulaWithShiftedIndexes);

  setVariables(variablesWithShiftedIndexes);
  setInputPosition(inputPosition + 1);

  setValue('');
  inputRef.current?.focus();
};
